import * as actions from "./actionsType";

const initialData = {
  loaderMetricJobExperience: false,
  metricJobExperience: null,
  metricJobExperienceAll: null,
  metricJobExperienceAnio: null,
  metricJobExperienceFalla: null,
  saveLoaderMetricJobExperience: false,
  metricJobExperienceFormError: null,
};

export default function MetricJobExperienceReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_METRIC_JOB_EXPERIENCE:
      return { ...state, loaderMetricJobExperience: action.payload };

    case actions.GET_METRIC_JOB_EXPERIENCE:
      return {
        ...state,
        metricJobExperience: action.payload.metricJobExperience,
        metricJobExperienceAll: action.payload.metricJobExperienceAll,
        metricJobExperienceAnio: action.payload.metricJobExperienceAnio,
      };

    case actions.METRIC_JOB_EXPERIENCE_FALLA:
      return { ...state, metricJobExperienceFalla: action.payload };

    case actions.SAVE_LOADER_METRIC_JOB_EXPERIENCE:
      return { ...state, saveLoaderMetricJobExperience: action.payload };

    case actions.FORM_METRIC_JOB_EXPERIENCE_FAIL:
      return { ...state, metricJobExperienceFormError: action.payload };

    default:
      return state;
  }
}
